export const propertyColumns = [
  { key: 'cracking', label: 'CRACKING' },
  { key: 'strength', label: 'STRENGTH' },
  { key: 'ductility', label: 'DUCTILITY' },
  { key: 'corrosion', label: 'CORROSION' },
  { key: 'temperature', label: 'TEMPERATURE' },
  { key: 'color', label: 'COLOR' },
  { key: 'pwht', label: 'PWHT' },
  { key: 'toughness', label: 'TOUGHNESS' },
];

export function getDistinctAlloys(data) {
  const setA = new Set();
  const setB = new Set();
  for (const pair of data.pairs || []) {
    if (pair.alloy_a) setA.add(pair.alloy_a);
    if (pair.alloy_b) setB.add(pair.alloy_b);
  }
  return { alloyA: Array.from(setA).sort(), alloyB: Array.from(setB).sort() };
}

export function getOptionsForPair(data, a, b) {
  if (!data || !data.pairs) return [];
  const match = data.pairs.find((p) => p.alloy_a === a && p.alloy_b === b);
  if (!match) return [];
  const options = (match.options || []).slice();
  options.sort((x, y) => {
    const xf = (x.filler || '').toLowerCase();
    const yf = (y.filler || '').toLowerCase();
    if (xf < yf) return -1;
    if (xf > yf) return 1;
    const xs = parseInt(x.sort_number || '0', 10);
    const ys = parseInt(y.sort_number || '0', 10);
    return xs - ys;
  });
  return options;
}

export function hasNotRecommended(options) {
  return options.some((o) => (o.filler || '').trim().toUpperCase() === 'NOT RECCOMMENDED');
}

// True when any recommended filler carries the ** marker (4043**, 4943**, 4043/4943**), which is
// what gates the Special Filler Metal Considerations footnote.
export function hasSpecialConsiderations(options) {
  return options.some((o) => (o.filler || '').includes('**'));
}
